const initialState = {
  data: 'Dev by Andi Irsandi',
  isLoading: false,
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'TESTCALL_PENDING':
      return {
        ...state,
        isLoading: true,
        message: '',
        trigger: false,
      };
    case 'TESTCALL_REJECTED':
      return {
        ...state,
        isLoading: false,
        message: payload?.response?.data?.message,
        error: true,
        severity: 'error',
      };
    case 'TESTCALL_FULFILLED':
      return {
        ...state,
        isLoading: false,
        error: false,
        message: payload.data.message,
        trigger: true,
        severity: 'success',
      };
    default:
      return state;
  }
}
